const filterForm = document.querySelector('.js--ajax-form');
const filterElements = document.querySelectorAll('.js--activate-form');

const productFilter = () => {
  filterElements.forEach((element) => {
    element.addEventListener('change', () => {
      filterForm.submit();
    });
  });
};

export default productFilter;
